import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "flatTableName",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "scope",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "flatTableName",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.flatTableName.$invalid && _ctx.v$.dataset.flatTableName.$dirty
                            }],
              modelValue: _ctx.v$.dataset.flatTableName.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.flatTableName.$model = $event)),
              modelModifiers: { trim: true },
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.flatTableName.$touch())),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.datasetManagement.flatTableName')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.dataset.flatTableName,
            additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.flatTableName') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Dropdown, {
              id: "dataSourceFlat",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.dataSourceFlat.$invalid && _ctx.v$.dataset.dataSourceFlat.$dirty
                            }],
              options: _ctx.dataSources,
              optionLabel: "label",
              optionValue: "label",
              modelValue: _ctx.v$.dataset.dataSourceFlat.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.dataset.dataSourceFlat.$model = $event)),
              onBeforeShow: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.dataset.dataSourceFlat.$touch()))
            }, null, 8, ["options", "modelValue", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.businessModelManager.dataSource')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.dataset.dataSourceFlat,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.businessModelManager.dataSource')
                        }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ])
      ])
    ]),
    _: 1
  }))
}